import React from 'react';

/**
 * Formats a message string with **bold** markers into JSX
 * Example: "This is **bold** text and **more bold** here" becomes proper JSX with strong tags
 */
export const formatMessage = (message: string): React.ReactNode => {
  const parts = message.split(/(\*\*.*?\*\*)/);

  return parts
    .map(part => {
      if (part.startsWith('**') && part.endsWith('**')) {
        // Remove the ** markers and wrap in strong tag
        const boldText = part.slice(2, -2);
        return <strong key={part}>{boldText}</strong>;
      }
      // Return regular text parts as React fragments with unique keys
      return part !== '' ? (
        <React.Fragment key={part}>{part}</React.Fragment>
      ) : null;
    })
    .filter(Boolean); // Remove null values
};
